module.exports = __webpack_public_path__ + "static/img/va-banner-f.92eb2d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/va-banner-f.png
// module id = vLzk
// module chunks = 1